export const useStyles = (theme) => ({
  drawerPaper: {
    paddingTop: 20,
    paddingBottom: 20,
    width: 200,
    height: "auto",
    display: "flex",
    background: `linear-gradient(to bottom,#96f389,#3db7f8)`,
    backdropFilter: `blur(4px)`,
    overflow: "hidden",
  },
  theme: {
    direction: "rtl1",
  },
  toolbar: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    color: "#fff",
  },
  linkStyle: {
    textDecoration: "none",
    color: "#181818",
    "&:hover": { textDecoration: "none" },
  },
  infoStyle: {
    padding: 20,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
});
